import { LayoutComponent } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colsSize: [1, 2],
        rowsSize: [0.7, 0.5],
        rowSpan: {
          "0:1": 2,
        },
        gap: "10px",
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide03-psychoacoustic-image01.svg`,
                    styles: {
                      height: "266px",
                    },
                  },
                },
              },
            },
            {
              variant: "layout",
              data: {
                type: "table",
                options: {
                  cols: 2,
                  rows: 4,
                  rowsSize: [1, 0, 1, 0],
                  components: [
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-psychoacoustic-image02.svg`,
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-psychoacoustic-image03.svg`,
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "text",
                            options: {
                              scrollbars: false,
                              data: "Loudness",
                              styles: {
                                fontSize: "10px",
                                fontWeight: 700,
                              },
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "text",
                            options: {
                              scrollbars: false,
                              data: "Sharpness",
                              styles: {
                                fontSize: "10px",
                                fontWeight: 700,
                              },
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-psychoacoustic-image04.svg`,
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-psychoacoustic-image05.svg`,
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "text",
                            options: {
                              scrollbars: false,
                              data: "Roughness",
                              styles: {
                                fontSize: "10px",
                                fontWeight: 700,
                              },
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "text",
                            options: {
                              scrollbars: false,
                              data: "Tonality",
                              styles: {
                                fontSize: "10px",
                                fontWeight: 700,
                              },
                            },
                          },
                        },
                      },
                    ],
                  ],
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    data:
                      "Following review, the selected measurements are then evaluated and described in terms of their psychoacoustic characteristics. By using parameters based on human sound perception, this process can lead to preliminary conclusions about the causes behind annoying or unpleasant sound components. High values in psychoacoustic components related with annoyance might provide a hint in the search for solutions or modifications to be made at the source (e.g. reduce vibrations, increase dampening, etc.).",
                    styles: {
                      fontSize: "12px",
                      fontWeight: 600,
                    },
                  },
                },
                styles: {
                  width: "93%",
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
      },
      styles: {
        borderBottom: `solid 1px ${variables["default-light"]}`,
      },
    },
  },
];

export default components;
